module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-right-square-370ae6b9.svg";